import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Checkbox } from '@bingads-webui-react/fabric-with-signal';
import { MessageBar } from '@fluentui/react';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { HelpLink } from '@bingads-webui-react/help-link';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

const getStyles = (_, { palette }) => ({
  predictiveMatchingSection: {
    '& .predictive-matching-header': {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'bold',
    },
    '& .predictive-matching-checkbox': {
      '& .ms-Checkbox-label': {
        fontWeight: 'bold',
      },
    },
    '& .predictive-matching-desc': {
      paddingLeft: 28,
    },

    '&.disabled p': {
      color: palette.neutralTertiaryAlt,
    },
  },
  messageBar: {
    background: palette.themeLighterAlt,
    marginBottom: 8,
  },
});

export const getPredictiveMatchingDetails = (i18n, autoGeneratedAssetsEnabled) => (autoGeneratedAssetsEnabled ? i18n.getString(_TL_('On')) : i18n.getString(_TL_('Off')));

export const PredictiveMatching = (props) => {
  const classes = useDefaultStyles(getStyles);
  const {
    AutoTargetingEnabled, isPredictiveMatchingChecked, onValidate, i18n, hideDescription, disabled,
  } = props;

  const activity = useContext(ActivityContext);

  const onChange = (e, v) => {
    onValidate({
      data: {
        isPredictiveMatchingChecked: v,
      },
      isValid: true,
    });
    if (activity) {
      activity.signal(`onPredictiveMatchingChange - ${v}`);
    }
  };

  return (
    <div className={classNames(classes.predictiveMatchingSection, disabled ? 'disabled' : '')}>
      {
        disabled && (
          <MessageBar className={classes.messageBar}>
            {i18n.getString(_TL_('Change bid strategy to enable.'))}
          </MessageBar>
        )
      }
      {!hideDescription &&
      <p className="predictive-matching-header">
        <span>{i18n.getString(_TL_('Do you want us to optimize your ad reach?'))}</span>
        <HelpPopup
          topic="pop_BA_Keywords_PredictiveMatching"
          aria-label={i18n.getString(_TL_('Click to learn more about predictive matching'))}
        />
      </p>
      }
      <div className="predictive-matching-checkbox">
        <Checkbox
          id="checkbox-predictive-matching"
          label={i18n.getString(_TL_('Enable predictive matching'))}
          checked={isPredictiveMatchingChecked === undefined ? AutoTargetingEnabled : isPredictiveMatchingChecked}
          onChange={onChange}
          disabled={disabled}
        />
        <p className="predictive-matching-desc">
          {i18n.getString(_TL_('Predictive matching acts as a complement to your existing keywords to match your ads with new, highly relevant search queries. Broad match will also be applied to keywords in your campaign to help you target all relevant search queries. '))}
          <HelpLink query="help:app54583">{i18n.getString(_TL_('Learn more'))}</HelpLink>
        </p>
      </div>
    </div>);
};

PredictiveMatching.propTypes = {
  onValidate: PropTypes.func.isRequired,
  isPredictiveMatchingChecked: PropTypes.bool.isRequired,
  AutoTargetingEnabled: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  hideDescription: PropTypes.bool,
  disabled: PropTypes.bool,
};

PredictiveMatching.defaultProps = {
  AutoTargetingEnabled: false,
  hideDescription: false,
  disabled: false,
};
